import React, { useState } from 'react';
import styled from 'styled-components';
import { colors, fonts } from '../styles/globals';

const FAQContainer = styled.section`
  background: linear-gradient(135deg, ${colors.background} 0%, ${colors.white} 100%);
  padding: 80px 20px;
  text-align: center;

  @media (max-width: 768px) {
    padding: 60px 20px;
  }
`;

const FAQContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const FAQTitle = styled.h2`
  font-family: ${fonts.playfair};
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  color: ${colors.primary};
  margin-bottom: 16px;
  line-height: 1.2;
`;

const FAQSubtitle = styled.p`
  font-family: ${fonts.inter};
  font-size: 1.2rem;
  font-weight: 500;
  color: ${colors.text};
  margin-bottom: 50px;
  line-height: 1.5;
`;

const FAQList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const FAQItem = styled.div`
  background: ${colors.white};
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(45, 31, 64, 0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 30px rgba(45, 31, 64, 0.15);
  }
`;

const FAQQuestion = styled.button`
  width: 100%;
  background: ${colors.white};
  border: none;
  padding: 25px 30px;
  text-align: left;
  cursor: pointer;
  font-family: ${fonts.playfair};
  font-size: 1.1rem;
  font-weight: 600;
  color: ${colors.primary};
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;

  &:hover {
    background: ${colors.background};
  }

  @media (max-width: 768px) {
    padding: 20px;
    font-size: 1rem;
  }
`;

const FAQAnswer = styled.div`
  padding: ${props => props.isOpen ? '0 30px 25px' : '0 30px'};
  max-height: ${props => props.isOpen ? '200px' : '0'};
  overflow: hidden;
  transition: all 0.3s ease;
  background: ${colors.white};

  @media (max-width: 768px) {
    padding: ${props => props.isOpen ? '0 20px 20px' : '0 20px'};
  }
`;

const FAQAnswerText = styled.p`
  font-family: ${fonts.inter};
  font-size: 1rem;
  color: ${colors.text};
  line-height: 1.6;
  margin: 0;
`;

const FAQIcon = styled.span`
  font-size: 1.2rem;
  transition: transform 0.3s ease;
  transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
`;

function FAQSection() {
  const [openFAQ, setOpenFAQ] = useState(null);

  const faqs = [
    {
      question: "¿Qué incluye el programa 'Habla Desde Tu Poder'?",
      answer: "El programa incluye 21 días de entrenamiento intensivo con sesiones en vivo, ejercicios prácticos, material de apoyo, acceso a la comunidad privada y seguimiento personalizado. También recibirás la guía exclusiva '3 claves para liberar tu voz con autenticidad'."
    },
    {
      question: "¿Necesito experiencia previa en oratoria?",
      answer: "No, no necesitas experiencia previa. El programa está diseñado para personas que quieren superar sus bloqueos emocionales y aprender a comunicarse desde la autenticidad, independientemente de su nivel de experiencia."
    },
    {
      question: "¿Cómo funciona el formato online?",
      answer: "Las sesiones se realizan en vivo a través de una plataforma online. Podrás interactuar con Eduardo y otros participantes en tiempo real, hacer preguntas y recibir feedback personalizado."
    },
    {
      question: "¿Qué pasa si no puedo asistir a alguna sesión?",
      answer: "Todas las sesiones se graban y estarán disponibles para que puedas verlas cuando quieras. Además, tendrás acceso a la comunidad privada donde puedes hacer preguntas y recibir apoyo."
    },
    {
      question: "¿Cuánto tiempo necesito dedicar al día?",
      answer: "Recomendamos dedicar entre 30-60 minutos al día para los ejercicios y prácticas. Las sesiones en vivo duran aproximadamente 90 minutos y se realizan 3 veces por semana."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <FAQContainer>
      <FAQContent>
        <FAQTitle>Preguntas Frecuentes</FAQTitle>
        <FAQSubtitle>
          Resolvemos tus dudas sobre el programa
        </FAQSubtitle>

        <FAQList>
          {faqs.map((faq, index) => (
            <FAQItem key={index}>
              <FAQQuestion onClick={() => toggleFAQ(index)}>
                {faq.question}
                <FAQIcon isOpen={openFAQ === index}>▼</FAQIcon>
              </FAQQuestion>
              <FAQAnswer isOpen={openFAQ === index}>
                <FAQAnswerText>{faq.answer}</FAQAnswerText>
              </FAQAnswer>
            </FAQItem>
          ))}
        </FAQList>
      </FAQContent>
    </FAQContainer>
  );
}

export default FAQSection; 